var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.93,
    height: 26.929,
    viewBox: "0 0 26.93 26.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.851,136.416a1.121,1.121,0,0,1-.8-.332L106.995,133a1.122,1.122,0,0,1,1.593-1.58l2.208,2.227,4.562-5.258a1.122,1.122,0,0,1,1.7,1.471L111.7,136.03a1.125,1.125,0,0,1-.81.386Z",
    transform: "translate(-101.059 -121.268)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.376,330.5a1.119,1.119,0,0,1-.793-.329l-7.832-7.832a1.122,1.122,0,0,1,1.587-1.587l7.832,7.832a1.122,1.122,0,0,1-.793,1.915Z",
    transform: "translate(-303.568 -303.568)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.94,21.88A10.94,10.94,0,1,1,21.88,10.94,10.953,10.953,0,0,1,10.94,21.88Zm0-19.636a8.7,8.7,0,1,0,8.7,8.7A8.706,8.706,0,0,0,10.94,2.244Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCheck);
export default __webpack_public_path__ + "static/media/search-check.e1c53feb2f60a7aaf7331cd92289f616.svg";
export { ForwardRef as ReactComponent };